export const TYPES = {
  SET_DEFAULT_WALLET_ALL: "default_wallet/SET_DEFAULT_WALLET_ALL",
};
